<template>
    <client-page>
        <!-- S: 서브 비주얼 -->
        <template #subHead>
            <sub-visual id="led" title="솔루션" src="/images/sub/subvisual-solution.jpg"></sub-visual>
        </template>
        <!-- E: 서브 비주얼 -->

        <page-section class="page-section--first">
            <template #titleLine>
                식물공장 시설
            </template>
            <tit-wrap-large class="mb-0">
                태양광을 대체하는 인공 고효율 스마트제어 <br class="d-none d-lg-block" /><b>LED 조명 시스템</b>
                <template #text> 에너지 절약과 동시에 광범위한 파장과 스펙트럼으로 <br class="d-none d-lg-block" />작물의 성장 단계에 따라 LED를 조절하여 효율적인 농업이 가능합니다. </template>
            </tit-wrap-large>
        </page-section>

        <page-section class="page-section--last grey lighten-5">
            <page-section class="page-section--sm py-0">
                <template #pageSectionImmersive>
                    <v-row class="mx-n20px my-n10px mx-md-n30px my-md-n20px">
                        <v-col cols="12" md="6" class="px-20px py-10px px-md-30px py-md-20px" data-aos="fade-left" data-aos-delay="200">
                            <v-card outlined rounded="">
                                <v-img max-width="570" :aspect-ratio="570 / 456" src="/images/sub/solution/plant/led-img.jpg" class="mx-auto" />
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="6" class="px-20px py-10px px-md-30px py-md-20px" data-aos="fade-right" data-aos-delay="200">
                            <div class="mt-md-24px">
                                <tit-wrap-sprout>
                                    LED 조명시스템
                                </tit-wrap-sprout>

                                <txt-item>
                                    <template #title>LED 특성</template>
                                    광도, 광량, 채도 등 빛을 효율적으로 제어 관리하여 작물의 생장에 알맞은 빛을 공급함으로써 작물의 생장 기간 및 발육 상태를 조절할 수 있습니다.
                                </txt-item>
                                <div class="mt-16px mt-md-24px">
                                    <v-card outlined tile class="rounded-tl-xl rounded-br-xl d-inline-block">
                                        <v-img width="126" :aspect-ratio="126 / 102" src="/images/sub/solution/plant/led-img2.jpg" />
                                    </v-card>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </template>
            </page-section>

            <page-section class="page-section--sm pb-0">
                <template #pageSectionImmersive>
                    <v-card outlined rounded="" class="d-flex align-center justify-center" data-aos="fade" data-aos-delay="100">
                        <div class="w-100 py-sm-20px py-lg-40px py-xl-100px">
                            <v-row no-gutters align="center" justify="center">
                                <v-col cols="12" sm="6" lg="auto">
                                    <div class="px-12px py-30px px-md-20px px-xl-60px">
                                        <v-img :width="$vuetify.breakpoint.lgAndUp ? 482 : '100%'" :aspect-ratio="482 / 494" src="/images/sub/solution/plant/led-img3.png" class="mx-auto" />
                                        <div class="mt-14px mt-md-20px text-center">
                                            <p class="txt txt--lg txt--dark">스마트 관제 시스템을 통해 원격 모니터링 및 제어가 가능해 <br class="d-none d-lg-block" />작물 재배의 편의성과 효율성이 높습니다.</p>
                                        </div>
                                    </div>
                                </v-col>
                                <v-col cols="auto" class="d-none d-lg-block align-self-stretch ml-n1px">
                                    <v-divider vertical class="h-100" />
                                </v-col>
                                <v-col cols="12" sm="6" lg="auto">
                                    <div class="px-12px py-20px px-md-20px px-xl-60px">
                                        <v-img :width="$vuetify.breakpoint.lgAndUp ? 354 : '100%'" :aspect-ratio="354 / 444" src="/images/sub/solution/plant/led-img4.png" class="mx-auto" />
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                    </v-card>
                </template>
            </page-section>

            <page-section class="page-section--sm pb-0">
                <template #pageSectionImmersive>
                    <v-row justify="center">
                        <v-col cols="12" md="6" lg="4" data-aos="fade" data-aos-delay="100">
                            <v-card outlined rounded="">
                                <v-img max-width="382" :aspect-ratio="382 / 540" src="/images/sub/solution/plant/led-img5.jpg" class="ma-auto" />
                            </v-card>
                            <tit-wrap-small mbSmall class="mt-14px mt-md-20px">
                                특허등록
                                <template #text>
                                    식물재배용 조명장치
                                </template>
                            </tit-wrap-small>
                        </v-col>
                    </v-row>
                </template>
            </page-section>
        </page-section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import PageSection from "@/pages/client/templates/page-section.vue";
import TitWrapSmall from "@/components/dumb/tit-wrap-small.vue";
import TitWrapLarge from "@/components/dumb/tit-wrap-large.vue";
import TitWrapSprout from "@/components/dumb/tit-wrap-sprout.vue";
import TxtItem from "@/components/dumb/txt-item.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
        PageSection,
        TitWrapSmall,
        TitWrapLarge,
        TitWrapSprout,
        TxtItem,
    },
    props: {},
    data() {
        return {
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.$nextTick(() => {});
        },
    },
};
</script>

<style lang="scss" scoped></style>
